import React, {Component} from 'react';
import Agenda from './index.js';
import Utils from '../utils';

class WithData extends Component{
  constructor(){
    super();
    this.state ={
      eventos : []
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Agenda", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrEventos = [];
      data.records.forEach(evento => {
        if (evento.fields.Activo) {
          arrEventos.push(evento);
        }
      });
      arrEventos = Utils.oldestFirst(arrEventos, "Fecha")

      this.setState({
          eventos : arrEventos
      });
    })
    .catch(error=>{
      console.error(error);
    })
  }

  render(){
    return (
      <div>
        <Agenda eventos={this.state.eventos}/>
      </div>
    )
  }
}

export default WithData;
